import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../Components/Form";
import {
    ListarCidadesController,
    ListarEstadosController,
} from "../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import {
    AtualizarFeriadoService,
    CadastrarFeriadoService,
} from "../../../../Services/Geral/Feriado/FeriadoService";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IFeriado } from "../../../../Interfaces/Geral/Feriado/FeriadoInterface";
import { ListarTiposFeriadosController } from "../../../../Controllers/Geral/Feriado/FeriadoController";

interface ICreateUpdateFeriados {
    setShow: (show: boolean) => void;
    updateList: () => void;
    row?: IFeriado;
}

export default function CreateUpdateFeriados(props: ICreateUpdateFeriados) {
    const { row, updateList } = props;

    const { execute: CadastrarFeriado, loading: CadastrarFeriadoLoading } =
        useAsyncCallback(CadastrarFeriadoService);

    const { execute: AtualizarFeriado, loading: AtualizarFeriadoLoading } =
        useAsyncCallback(AtualizarFeriadoService);

    function handleSubmit(formData: IFeriado) {
        if (row && row.ID_FERIADO) {
            AtualizarFeriado(row.ID_FERIADO, {
                ...formData,
                ID_PAIS: 1,
            }).then(() => {
                if (updateList) updateList();
                props.setShow(false);
            });
        } else {
            CadastrarFeriado({ ...formData, ID_PAIS: 1 }).then(() => {
                if (updateList) updateList();
                props.setShow(false);
            });
        }
    }

    return (
        <UnForm handleSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-12">
                    <UnForm.Input
                        name="DS_FERIADO"
                        label="Descrição"
                        registerOptions={{
                            required: "Informe a descrição do feriado",
                        }}
                        defaultValue={row?.DS_FERIADO}
                    />
                </div>
                <div className="col-md-6">
                    <UnForm.Input
                        type="date"
                        name="DT_FERIADO"
                        label="Data"
                        registerOptions={{
                            required: "Informe a data do feriado",
                        }}
                        defaultValue={row?.DT_FERIADO.split("T")[0]}
                    />
                </div>
                <div className="col-md-6">
                    <UnForm.LazySelect
                        controller={ListarTiposFeriadosController}
                        getDS={(ds) => ds.DS_TIPO_FERIADO}
                        getKeyValue={(key) => key.ID_TIPO_FERIADO}
                        name="ID_TIPO_FERIADO"
                        label="Tipo"
                        registerOptions={{
                            required: "Informe o tipo de feriado",
                        }}
                        defaultValue={row?.ID_TIPO_FERIADO}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
                {/* <div className="col-md-6">
                    <UnForm.Input name="DS_PAIS" label="País" />
                </div> */}
                <div className="col-md-6">
                    <UnForm.LazySelect
                        controller={ListarEstadosController}
                        getDS={(ds) => ds.DS_ESTADO}
                        getKeyValue={(key) => key.ID_ESTADO}
                        name="ID_ESTADO"
                        label="Estado"
                        defaultValue={row?.ID_ESTADO}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-md-6">
                    {/* {lstCidadesLoading ? (
                        <div className="d-flex justify-content-center w-100 mt-3">
                            <Spinner size="sm" color="primary" />
                        </div>
                    ) : ( */}
                    <UnForm.LazySelect
                        name="ID_CIDADE"
                        label="Cidade"
                        fatherName="ID_ESTADO"
                        defaultValue={row?.ID_CIDADE}
                        controller={ListarCidadesController}
                        getDS={(ds) => ds.DS_CIDADE}
                        getKeyValue={(key) => key.ID_CIDADE}
                    >
                        <option></option>
                        {/* {lstCidades &&
                            lstCidades.map((cidade) => (
                                <option
                                    key={cidade.ID_CIDADE}
                                    value={cidade.ID_CIDADE}
                                >
                                    {cidade.DS_CIDADE}
                                </option>
                            ))} */}
                    </UnForm.LazySelect>
                    {/* )} */}
                </div>
                <div className="col-md-12">
                    <UnForm.SubmitButton
                        icon={row ? faEdit : faPlus}
                        color={row ? "primary" : "success"}
                        className="w-100 mt-5"
                        wrapperClassName="w-100"
                        disabled={
                            CadastrarFeriadoLoading || AtualizarFeriadoLoading
                        }
                        loading={
                            CadastrarFeriadoLoading || AtualizarFeriadoLoading
                        }
                        loadingSize="sm"
                    >
                        {row ? "Editar" : "Salvar"}
                    </UnForm.SubmitButton>
                </div>
            </div>
        </UnForm>
    );
}
